// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResultInfo__container-a14bb5 {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.SearchResultInfo__text-e2d3de {
  color: var(--base-80);
  margin-inline-start: 8px;
  font: var(--font-body-4);
  letter-spacing: var(--font-body-4);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SearchResult/SearchResultInfo/SearchResultInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,wBAAA;EACA,kCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n}\n\n.text {\n  color: var(--base-80);\n  margin-inline-start: 8px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-body-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchResultInfo__container-a14bb5`,
	"text": `SearchResultInfo__text-e2d3de`
};
module.exports = ___CSS_LOADER_EXPORT___;
